module.exports = __webpack_public_path__ + "static/media/11NEPAD5.8d5ae698.jpg";